import { render, staticRenderFns } from "./VSyncIcon.vue?vue&type=template&id=ec188204&scoped=true"
import script from "./VSyncIcon.vue?vue&type=script&lang=js"
export * from "./VSyncIcon.vue?vue&type=script&lang=js"
import style0 from "./VSyncIcon.vue?vue&type=style&index=0&id=ec188204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec188204",
  null
  
)

export default component.exports